// Shared child identity colours for cards and Settings. Colours are UI metadata only.
export const CHILD_COLOURS = {
  sage: { label: "Green", dot: "bg-[#4A7C59]", ring: "bg-[#E7EFE7] text-[#2F5C3E]" },
  slate: { label: "Navy", dot: "bg-[#1A365D]", ring: "bg-[#EEF2F7] text-[#1A365D]" },
  clay: { label: "Coral", dot: "bg-[#D97757]", ring: "bg-[#FBEDE5] text-[#8A3E20]" },
  sand: { label: "Gold", dot: "bg-[#9B741C]", ring: "bg-[#FAF1D8] text-[#745515]" },
  sky: { label: "Blue", dot: "bg-[#237FAD]", ring: "bg-[#E4F2FA] text-[#155A7C]" },
  petal: { label: "Purple", dot: "bg-[#8555A3]", ring: "bg-[#F1E9F7] text-[#63377E]" },
  citrus: { label: "Teal", dot: "bg-[#197A74]", ring: "bg-[#E1F3F0] text-[#155E59]" },
};
export const validChildColour = key =>
  Object.prototype.hasOwnProperty.call(CHILD_COLOURS, key || "") ||
  /^hue-(\d{1,3})$/.test(key || "") && Number(key.slice(4)) < 360;

export const childColour = key => {
  if (CHILD_COLOURS[key]) return CHILD_COLOURS[key];
  if (validChildColour(key)) {
    const hue = Number(key.slice(4));
    return { label: "Additional colour", dot: "", ring: "",
      dotStyle: { backgroundColor: `hsl(${hue} 45% 38%)` },
      ringStyle: { backgroundColor: `hsl(${hue} 55% 93%)`, color: `hsl(${hue} 50% 28%)` } };
  }
  return CHILD_COLOURS.sage;
};

// Resolve legacy missing/duplicate colours without writing to the database.
// Stable IDs make the result independent of API order and unchanged by renaming.
export const distinctChildColours = (children = {}) => {
  const entries = Object.entries(children).sort(([a], [b]) => a.localeCompare(b));
  const used = new Set();
  const result = {};
  const pending = [];
  for (const [id, child] of entries) {
    if (validChildColour(child.colorKey) && !used.has(child.colorKey)) {
      result[id] = { ...child };
      used.add(child.colorKey);
    } else pending.push([id, child]);
  }
  for (const [id, child] of pending) {
    let colour = Object.keys(CHILD_COLOURS).find(key => !used.has(key));
    if (!colour) {
      for (let index = 0; index < 360; index += 1) {
        const key = `hue-${(index * 137) % 360}`;
        if (!used.has(key)) { colour = key; break; }
      }
    }
    result[id] = { ...child, colorKey: colour || "sage" };
    used.add(result[id].colorKey);
  }
  return Object.fromEntries(Object.keys(children).map(id => [id, result[id]]));
};
